import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import { setDashboardParams, setSessionVar } from '../../store/actions';
import NavBaseTemplate from '../templates/NavBaseTemplate';
import DataTable from '../theme/tables/DataTableX';
import FromToDatePickerInput from '../theme/forms/FromToDatePickerInput';
import Moment from 'moment';
import FeedbackTile from '../theme/modals/FeedbackTile';
import DashboardOfficeSelector from '../theme/dashboard/selectors/DashboardOfficeSelector';
import DashTabs from '../theme/menus/DashTabs';
import api from '../../store/api/api';
import ImageViewBox from '../imgs/imageViewBox';
import DashboardShiftSelector from '../theme/dashboard/selectors/DashboardShiftSelector';
import DashboardRouteSelector from '../theme/dashboard/selectors/DashboardRouteSelector';
import { store } from '../../store';
import { schema } from '../theme/tables/schema';
import BaseModal from '../theme/modals/BaseModal';
import DataTimeline from '../theme/tables/DataTimeline';
import { Link } from 'react-router-dom';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: {},
      canvasser: false,
      modalTitle: false,
    };

    this.SUBMIT_DATE_FORMAT = 'YYYY-MM-DD';

    this.updateInterval = [];

    this.closeTimeline = this.closeTimeline.bind(this);
  }

  handleDateChange = (start, end) => {
    this.props.setDashboardParams({
      start: start.getTime(),
      end: end.getTime(),
    });
  };

  refresh(everything) {
    if (everything) {
      this.pullDataSet('campaign');
      this.pullDataSet('offices');
    }
    this.pullDataSet('canvassers');
    if (this.props.dashboardParams.selectedOffice > 0) {
      this.pullDataSet('routes');
      this.pullDataSet('shifts');
    }
  }

  componentDidMount() {
    this.refresh(true);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.focusedCampaign.id !== this.props.focusedCampaign.id ||
      prevProps.dashboardParams.start !== this.props.dashboardParams.start ||
      prevProps.dashboardParams.end !== this.props.dashboardParams.end
    ) {
      if (prevProps.focusedCampaign.id !== this.props.focusedCampaign.id) {
        this.props.setDashboardParams({
          selectedShift: 0,
          selectedRoute: 0,
          selectedOffice: 0,
        });
      }
      this.refresh(true);
    } else if (
      prevProps.dashboardParams.selectedOffice !== this.props.dashboardParams.selectedOffice ||
      prevProps.dashboardParams.selectedShift !== this.props.dashboardParams.selectedShift ||
      prevProps.dashboardParams.selectedRoute !== this.props.dashboardParams.selectedRoute
    ) {
      this.refresh(false);
    }
  }

  buildParams() {
    const params = {
      start: Moment(this.props.dashboardParams.start).format(this.SUBMIT_DATE_FORMAT),
      end: Moment(this.props.dashboardParams.end).format(this.SUBMIT_DATE_FORMAT),
      campaign: this.props.focusedCampaign.id,
    };
    if (this.props.dashboardParams.selectedOffice > 0) {
      params.office = this.props.dashboardParams.selectedOffice;
    }
    if (this.props.dashboardParams.selectedRoute > 0) {
      params.route = this.props.dashboardParams.selectedRoute;
    }
    if (this.props.dashboardParams.selectedShift > 0) {
      params.shift = this.props.dashboardParams.selectedShift;
    }
    return params;
  }

  pullDataSet(type) {
    const loading = { ...this.state.loading };
    loading[type] = true;
    this.setState(loading);

    store.dispatch(actions.setCampaignSubAggregates(type, null));

    api
      .get(`/aggregates/${type}`, this.buildParams())
      .then((res) => {
        store.dispatch(actions.setCampaignSubAggregates(type, res.data));
        const loading = { ...this.state.loading };
        loading[type] = false;
        this.setState(loading);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  buildTable(type, title) {
    if (!this.props.aggregates[type]) {
      return (
        <div className={'loading'} style={{ marginBottom: 10 }}>
          Loading {type}
        </div>
      );
    }
    if (
      Array.isArray(this.props.aggregates[type].rows) &&
      this.props.aggregates[type].rows.length > 0
    ) {
      if (type === 'campaign' && this.props.aggregates[type].rows.every((r) => !r.name)) {
        return null;
      }

      // TODO: filter out columns where all values are NULL for types other than "campaign"
      //      let show_site_metrics = this.props.aggregates[type].rows.some((d) => d.num_sites_checked_into > 0);
      //      let show_door_metrics = this.props.aggregates[type].rows.some((d) => d.num_people_canvassed > 0);

      const columns = schema(type);
      const attrs = {};
      if (type === 'offices') {
        const office = this.props.aggregates[type].rows.find(
          (o) => o.id === this.props.dashboardParams.selectedOffice
        );
        if (office) {
          attrs.searchText = office.name;
        }
      } else if (type === 'canvassers') {
        console.log(
          '[LATEALERTS] Processing canvassers data for alarm system. Row count:',
          this.props.aggregates[type].rows.length
        );
        columns.forEach((col) => {
          col.onClick = (row) => {
            this.setState({
              canvasser: row,
              modalTitle: `${row.canvasser_name || row.name}'s Events`,
            });
          };
          if (col.field === 'yards_from_target') {
            col.renderCell = ({ row }) => {
              const hasAlarm = this._canvasserHasDistanceAlarm(row);
              if (hasAlarm) {
                console.log(
                  '[LATEALERTS] Styling yards_from_target cell for:',
                  row.canvasser_name || row.name,
                  'value:',
                  row.yards_from_target
                );
              }
              return (
                <span className={hasAlarm ? 'danger-text is-semibold' : ''}>
                  {row.yards_from_target >= 0 ? row.yards_from_target : '--'}
                </span>
              );
            };
          } else if (col.field === 'minutes_since_last_contact') {
            col.renderCell = ({ row }) => {
              const hasAlarm = this._canvasserHasTimeAlarm(row);
              if (hasAlarm) {
                console.log(
                  '[LATEALERTS] Styling minutes_since_last_contact cell for:',
                  row.canvasser_name || row.name,
                  'value:',
                  row.minutes_since_last_contact
                );
              }
              return (
                <span className={hasAlarm ? 'danger-text is-semibold' : ''}>
                  {row.minutes_since_last_contact || '--'}
                </span>
              );
            };
          }
        });

        // TODO: fix by normalizing Stored Procedures
        const hasName = columns.findIndex((f) => f.field === 'canvasser_name');
        if (hasName > -1) {
          columns[hasName].renderCell = ({ row }) => {
            return row.canvasser_name || row.name;
          };
        }

        const hasLatLng = columns.find((f) => f.field === 'latitude');
        if (hasLatLng) {
          columns.push({
            field: 'last_location',
            headerName: 'Last Location',
            type: 'number',
            sortable: true,
            filterable: false,
            showing: true,
            renderCell: function ({ row }) {
              const date = new Date(
                row.first_site_contact_attempt_time ||
                  row.last_response ||
                  row.last_door_attempt_time ||
                  row.last_location_update_time
              );
              if (date && date.getTime() > 0) {
                // TODO: use locale time not utc
                const dateOnly = date.toISOString().substring(0, 10);
                const tolink = `/map?start=${dateOnly}&canvasser=${row.canvasser_id}`;
                return row.latitude && row.longitude ? (
                  <Link to={tolink}>
                    {row.latitude}, {row.longitude}
                  </Link>
                ) : (
                  'No Location'
                );
              } else {
                console.log('No date!?', row);
              }
              return null;
            },
          });
        }

        const hasSiteId = columns.findIndex((f) => f.field === 'site_name');
        if (hasSiteId > -1) {
          columns[hasSiteId].renderCell = ({ row }) => {
            if (row.site_name) {
              return (
                <div>
                  <div style={{ fontWeight: 600 }}>{row.site_name}</div>
                  <div style={{ fontSize: '80%' }}>
                    {row.site_addressline1} {row.site_addressline2} <br />
                    {row.site_city}, {row.site_statecode} {row.site_zip5}
                  </div>
                </div>
              );
            }
            return null;
          };
        }
      }

      return (
        <DataTable
          showFooter={false}
          rows={this.props.aggregates[type].rows}
          {...attrs}
          title={title}
          columns={columns}
          getRowStyle={
            type === 'canvassers'
              ? (row) => {
                  const hasTimeAlarm = this._canvasserHasTimeAlarm(row);
                  const hasDistanceAlarm = this._canvasserHasDistanceAlarm(row);
                  const shouldHighlight = hasTimeAlarm || hasDistanceAlarm;

                  if (shouldHighlight) {
                    console.log(
                      '[LATEALERTS] Highlighting row for canvasser:',
                      row.canvasser_name || row.name,
                      {
                        hasTimeAlarm,
                        hasDistanceAlarm,
                        yards_from_target: row.yards_from_target,
                        minutes_since_last_contact: row.minutes_since_last_contact,
                      }
                    );
                  }

                  return shouldHighlight ? { backgroundColor: 'rgba(188, 64, 64, 0.12)' } : null;
                }
              : undefined
          }
        />
      );
    }
    return null;
  }

  closeTimeline = () => {
    this.setState({ modalData: false, modalTitle: false });
  };

  _startIsToday = () => {
    const isToday =
      new Date(this.props.dashboardParams.start).toDateString() === new Date().toDateString();
    console.log('[LATEALERTS] Checking if start date is today:', {
      startDate: new Date(this.props.dashboardParams.start).toDateString(),
      today: new Date().toDateString(),
      isToday,
    });
    return isToday;
  };

  _canvasserHasDistanceAlarm = (cdata) => {
    const hasAlarm = (cdata?.yards_from_target || 0) > 500 && this._startIsToday();
    if (hasAlarm) {
      console.log(
        '[LATEALERTS] Distance alarm triggered for canvasser:',
        cdata.canvasser_name || cdata.name,
        'yards:',
        cdata?.yards_from_target
      );
    }
    return hasAlarm;
  };

  _canvasserHasTimeAlarm = (cdata) => {
    const hasAlarm = (cdata?.minutes_since_last_contact || 0) > 25 && this._startIsToday();
    if (hasAlarm) {
      console.log(
        '[LATEALERTS] Time alarm triggered for canvasser:',
        cdata.canvasser_name || cdata.name,
        'minutes:',
        cdata?.minutes_since_last_contact
      );
    }
    return hasAlarm;
  };

  render() {
    return (
      <NavBaseTemplate>
        <DashTabs />
        <h3 className={'primary-text'}>Activity Counts</h3>
        <div className="dashboard-filters">
          <div className="dashboard-filter">
            <FromToDatePickerInput
              handleDateChange={this.handleDateChange}
              from={new Date(this.props.dashboardParams.start)}
              to={new Date(this.props.dashboardParams.end)}
              isloading={this.state.loading.campaign}
            />
          </div>

          <div className="dashboard-filter">
            <DashboardOfficeSelector isloading={this.state.loading.offices} />
          </div>

          {this.props.dashboardParams.selectedOffice > 0 && (
            <div className="dashboard-filter">
              <DashboardRouteSelector isloading={this.state.loading.routes} />
            </div>
          )}

          {this.props.dashboardParams.selectedOffice > 0 && (
            <div className="dashboard-filter">
              <DashboardShiftSelector isloading={this.state.loading.shifts} />
            </div>
          )}
        </div>

        {this.state.modalTitle && (
          <BaseModal
            showCloseIcon={true}
            onClose={this.closeTimeline}
            open={typeof this.state.modalTitle === 'string'}
            title={this.state.modalTitle}
            center
            classNames={{ modal: 'baseModal' }}
            styles={{
              modal: { width: '100%', maxWidth: 'none' },
            }}
          >
            <DataTimeline canvasser={this.state.canvasser} />
          </BaseModal>
        )}

        {this.buildTable('campaign', 'Campaign')}
        {this.buildTable('offices', 'Offices')}
        {this.props.dashboardParams.selectedOffice > 0 && (
          <React.Fragment>
            {this.buildTable('routes', 'Routes')}
            {this.buildTable('shifts', 'Shifts')}
          </React.Fragment>
        )}
        {this.buildTable('canvassers', 'canvassers')}

        <FeedbackTile
          text={
            <div>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: '15px' }} />
              There was a server error.
            </div>
          }
          visible={this.props.aggregates.error}
          backgroundColor={'red'}
        />

        <ImageViewBox />
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  aggregates: state.aggregates,
  all_offices: state.offices.data,
  campaigns: state.campaigns?.data,
  focusedCampaign: state.session.focusedCampaign,
  is_admin: state.permissions.is_admin,
  dashboardParams: state.dashboardParams,
  sessionVars: state.session.vars,
});

const mapDispatchToProps = (dispatch) => ({
  setDashboardParams: (data) => dispatch(setDashboardParams(data)),
  setSessionVar: (key, value) => dispatch(setSessionVar(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
